import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setSearchParams,
  fetchSearchResults,
  updateSearchField,
} from "../store/slices/searchSlice";
import { useNavigate, Link } from "react-router-dom";

const MegaMenu = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [openDropdowns, setOpenDropdowns] = useState({});

  const dropdownRefs = useRef([]);
  const { categories, status, error } = useSelector(
    (state) => state.categories
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClickOutside = (event) => {
    if (categories && categories.length > 0) {
      dropdownRefs.current.forEach((ref, index) => {
        if (ref && !ref.contains(event.target)) {
          const categoryId = categories[index]?.id;
          if (categoryId) {
            setOpenDropdowns((prev) => ({
              ...prev,
              [categoryId]: false,
            }));
          }
        }
      });
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [categories]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prevState) => !prevState);
  };

  const handleCategoryClick = (category) => {
    if (category.parent_id === null) {
      setSelectedCategory(
        category.children && category.children[0] ? category.children[0] : null
      );
      setOpenDropdowns((prev) => ({
        ...prev,
        [category.id]: !prev[category.id],
      }));
    } else if (category.children && category.children.length > 0) {
      setSelectedCategory(category);
    }
  };
 const handleCategorySet = (subCategory) => {
  
        // Mettre à jour la valeur de `query` avec le nom de la sous-catégorie
        dispatch(updateSearchField({ field: 'query', value: subCategory.name }));
        const searchData = {
          categoryId: subCategory.id || null,
          filtre: [],
          disponibilite:'all-time',
          when: "all_time",
          sortBy: "relevance",
          search_query:subCategory.name,
          query:subCategory.name
        };
        // Mettre à jour la valeur de `categoryId` avec l'ID de la sous-catégorie
        dispatch(updateSearchField({ field: 'categoryId', value: subCategory.id }));
        dispatch(fetchSearchResults(searchData));
        navigate("/resultats", { replace: true });
    };
  const handleCategorySelect = (subcategory,category) => {
    // console.log({category})
    const searchData = {
      query: subcategory.name,
      categoryId: subcategory.id,
      categoryName: category.name,
    };
    dispatch(setSearchParams(searchData));
    dispatch(fetchSearchResults(searchData)); // Trigger API call
    setOpenDropdowns({});
    navigate("/resultats", { replace: true });
  };

  if (status === "loading") {
    return <div></div>;
  }

  if (status === "failed") {
    return <div className="container body">Erreur de chargement : Chargement en cours...</div>;
  }

  return (
    <div className="container-fluid twyny-navmenu">
      <nav className="container navbar navbar-expand-lg">
        <div className="container-fluid">
          <button
            className="navbar-toggler px-0 d-lg-none d-md-block d-block"
            type="button"
            onClick={toggleMobileMenu}
            aria-controls="navbarExample2"
            aria-expanded={isMobileMenuOpen ? "true" : "false"}
            aria-label="Toggle navigation"
          >
            <i className="fas fa-bars"></i>
          </button>

          <div
            className={`collapse navbar-collapse ${isMobileMenuOpen ? "show" : ""
              }`}
            id="navbarExample2"
          >
            <ul className="navbar-nav me-auto ps-lg-0 twyny-ul-navbar">
              {categories &&
                categories.map((category, index) => {
                  const dropdownId = `dropdownMenu${category.id}`;
                  return (
                    <div
                      key={index}
                      className="nav-item dropdown position-static"
                      ref={(el) => (dropdownRefs.current[index] = el)}
                    >
                      <button
                        className="nav-link dropdown-toggle twyny-parent-link twyny-flex"
                        onClick={() => handleCategoryClick(category)}
                        id={dropdownId}
                        aria-expanded={
                          openDropdowns[category.id] ? "true" : "false"
                        }
                        aria-haspopup="true"
                      >
                        <img
                          className="twyny-icon-menu"
                          src={`${process.env.REACT_APP_FILE_URL}${category.icon}`}
                          alt={category.name}
                        />
                        {category.name}
                      </button>

                      <div
                        className={`dropdown-menu w-100 mt-0 ${openDropdowns[category.id] ? "show" : ""
                          }`}
                        aria-labelledby={dropdownId}
                        style={{
                          borderTopLeftRadius: "0",
                          borderTopRightRadius: "0",
                          position: "absolute",
                          top: "100%",
                          left: "0",
                          width: "100%",
                        }}
                      >
                        <div className="container">
                          <div className="row">
                            <div className="col-md-6 col-lg-4 twyny-padding-40 twyny-white-background d-flex flex-column">
                              <p className="pointer nav-title d-flex align-center grey500" onClick={()=>handleCategorySet(category)}>
                                {category.name}
                                <img
                                  src="/images/arrow-right.png"
                                  className="arrow"
                                  alt="arrow"
                                />
                              </p>
                              <div className="subtitle legend grey66">
                                CATÉGORIES
                              </div>
                              <div className="twynn">
                                {category.children &&
                                  category.children.map((subCategory) => (
                                    <div
                                      className="url-twyny"
                                      key={subCategory.id}
                                      onClick={() => handleCategoryClick(subCategory)}
                                    >
                                      <button
                                        className="link-twyny"
                                        
                                      >
                                        {subCategory.name}
                                      </button>
                                      <img
                                        src="/images/arrow-right-dark.svg"
                                        className="arrow-hover"
                                        alt="arrow"
                                      />
                                    </div>
                                  ))}
                              </div>
                            </div>

                            <div className="col-md-6 col-lg-6 twyny-padding-40 d-flex flex-column">
                              {selectedCategory && selectedCategory.children && (
                                <div className="flex-grow-1">
                                  <div className="subtitle">SERVICES</div>
                                  {selectedCategory.children.length % 2 === 0 && selectedCategory.children.length < 7 ? (
                                    <div className="row">
                                      <div className="col-md-6 d-flex flex-column">
                                        <div className="child">
                                          {selectedCategory.children.map((subCategory) => (
                                            <div
                                              key={subCategory.id}
                                              className="link-service-twyny"
                                              onClick={() =>
                                                handleCategorySelect(subCategory,category)
                                              }
                                            >
                                              {subCategory.name}
                                            </div>
                                          ))}
                                        </div>
                                        <div className="voir-tout mt-2">
                                          <Link to="/category" className="link-blue">
                                            Voir tout
                                            <img
                                              src="/images/arrow-right.svg"
                                              className="arrow ml-8"
                                              alt="Arrow"
                                            />
                                          </Link>
                                        </div>
                                      </div>
                                      <div className="col-md-6"></div>
                                    </div>
                                  ) : (
                                    <div className="row">
                                      <div className="col-md-6">
                                        {selectedCategory.children
                                          .slice(0, Math.ceil(selectedCategory.children.length / 2))
                                          .map((subCategory) => (
                                            <div
                                              key={subCategory.id}
                                              className="link-service-twyny"
                                              onClick={() =>
                                                handleCategorySelect(subCategory,category)
                                              }
                                            >
                                              {subCategory.name}
                                            </div>
                                          ))}
                                      </div>
                                      <div className="col-md-6 d-flex flex-column">
                                        <div className="child">
                                          {selectedCategory.children
                                            .slice(Math.ceil(selectedCategory.children.length / 2))
                                            .map((subCategory) => (
                                              <div
                                                key={subCategory.id}
                                                className="link-service-twyny"
                                                onClick={() =>
                                                  handleCategorySelect(subCategory,category)
                                                }
                                              >
                                                {subCategory.name}
                                              </div>
                                            ))}
                                        </div>
                                        <div className="voir-tout mt-2">
                                          <Link to="/category" className="link-blue">
                                            Voir tout
                                            <img
                                              src="/images/arrow-right.svg"
                                              className="arrow ml-8"
                                              alt="Arrow"
                                            />
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default MegaMenu;